import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaRadioGroup } from './KaRadioGroup.vue';

export type { KaRadioGroupOption, KaRadioGroupOptionValue, KaRadioGroupProps } from './types';

export const KaRadioGroupVee = veeFormFieldHOC(KaRadioGroup);

export { KaRadioGroup };
